import CVCDatePicker from './CVCDatePicker.view';

export default CVCDatePicker;
